import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

export const TypeaheadComponentName = 'Typeahead' as const;
export const TypeaheadParts = ['input', 'dropdown', 'item'] as const;

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(TypeaheadParts);

const baseStyle = definePartsStyle({
  input: {},
  dropdown: {
    backgroundColor: 'white',
    boxShadow: 'heavy',
    position: 'absolute',
    top: '100%',
    width: '100%',
    zIndex: 999,
  },
  item: {
    textAlign: 'left',
    px: 1,
    backgroundColor: 'transparent',
    _hover: {
      backgroundColor: 'neutral.50',
    },
  },
});

export const TypeaheadStyle = defineMultiStyleConfig({ baseStyle });
